import { CampaignPricesDTO, ItemCampaignPriceDTO } from '../../dto';

export interface CampaignPricesPropsProps {
  active: ItemCampaignPrice[];
  future: ItemCampaignPrice[];
}

export class CampaignPrices {
  active: ItemCampaignPrice[];
  future: ItemCampaignPrice[];

  constructor({ active, future }: CampaignPricesPropsProps) {
    this.active = active;
    this.future = future;
  }

  static fromDTO = (dto: CampaignPricesDTO): CampaignPrices =>
    new CampaignPrices({
      active: dto.active.map(ItemCampaignPrice.fromDTO),
      future: dto.future.map(ItemCampaignPrice.fromDTO),
    });
}

export interface ItemCampaignPriceProps {
  campaignName: string;
  unit: string;
  salesPriceIncVat: number;
  salesPriceExVat: number;
  purchasePriceIncVat: number;
  purchasePriceExVat: number;
  purchasePeriodFrom: string;
  purchasePeriodTo: string;
  campaignValidFrom: string;
  campaignValidTo: string;
}

export class ItemCampaignPrice {
  campaignName: string;
  unit: string;
  salesPriceIncVat: number;
  salesPriceExVat: number;
  purchasePriceIncVat: number;
  purchasePriceExVat: number;
  purchasePeriodFrom: string;
  purchasePeriodTo: string;
  campaignValidFrom: string;
  campaignValidTo: string;

  constructor({
    campaignName,
    unit,
    salesPriceIncVat,
    salesPriceExVat,
    purchasePriceIncVat,
    purchasePriceExVat,
    purchasePeriodFrom,
    purchasePeriodTo,
    campaignValidFrom,
    campaignValidTo,
  }: ItemCampaignPriceProps) {
    this.campaignName = campaignName;
    this.unit = unit;
    this.salesPriceIncVat = salesPriceIncVat;
    this.salesPriceExVat = salesPriceExVat;
    this.purchasePriceIncVat = purchasePriceIncVat;
    this.purchasePriceExVat = purchasePriceExVat;
    this.purchasePeriodFrom = purchasePeriodFrom;
    this.purchasePeriodTo = purchasePeriodTo;
    this.campaignValidFrom = campaignValidFrom;
    this.campaignValidTo = campaignValidTo;
  }

  static fromDTO = (dto: ItemCampaignPriceDTO): ItemCampaignPrice =>
    new ItemCampaignPrice({
      campaignName: dto.campaignName,
      unit: dto.unit,
      salesPriceIncVat: dto.salesPriceIncVat,
      salesPriceExVat: dto.salesPriceExVat,
      purchasePriceIncVat: dto.purchasePriceIncVat,
      purchasePriceExVat: dto.purchasePriceExVat,
      purchasePeriodFrom: dto.purchasePeriodFrom,
      purchasePeriodTo: dto.purchasePeriodTo,
      campaignValidFrom: dto.campaignValidFrom,
      campaignValidTo: dto.campaignValidTo,
    });
}
